import { createAtomObserver } from '@exodus/atoms'

const createFiatRampPlugin = ({
  fiatRamp,
  fiatOrders,
  fiatOrdersMonitor,
  fiatAssetsAtom,
  fiatConfigAtom,
  fiatCountriesAtom,
  fiatHiddenFailedOrderNotificationsAtom,
  fiatOrdersAtom,
  fiatUserAtom,
  port,
}) => {
  const observers = [
    createAtomObserver({ atom: fiatAssetsAtom, port, event: 'fiatAssets' }),
    createAtomObserver({ atom: fiatCountriesAtom, port, event: 'fiatCountries' }),
    createAtomObserver({
      atom: fiatHiddenFailedOrderNotificationsAtom,
      port,
      event: 'fiatHiddenFailedOrderNotifications',
    }),
    createAtomObserver({ atom: fiatOrdersAtom, port, event: 'fiatOrders' }),
    createAtomObserver({ atom: fiatUserAtom, port, event: 'fiatUser' }),
    createAtomObserver({ atom: fiatConfigAtom, port, event: 'fiatConfig' }),
  ]

  observers.forEach((observer) => observer.register())

  const onClear = async () => {
    fiatOrdersMonitor.stop()
    await fiatOrders.clear()
  }

  const onUnlock = () => {
    fiatRamp.load().then(() => {
      fiatOrdersMonitor.start()
    })

    observers.forEach((observer) => observer.start())
  }

  const onLoad = ({ isLocked }) => {
    if (isLocked) return

    observers.forEach((observer) => observer.start())
  }

  const onStop = () => {
    observers.forEach((observer) => observer.unregister())
    fiatRamp.stop()
  }

  return { onUnlock, onLoad, onStop, onClear }
}

const fiatRampPluginDefinition = {
  id: 'fiatRampPlugin',
  type: 'plugin',
  factory: createFiatRampPlugin,
  dependencies: [
    'fiatRamp',
    'fiatOrders',
    'fiatOrdersMonitor',
    'fiatAssetsAtom',
    'fiatConfigAtom',
    'fiatCountriesAtom',
    'fiatHiddenFailedOrderNotificationsAtom',
    'fiatOrdersAtom',
    'fiatUserAtom',
    'port',
  ],
  public: true,
}

export default fiatRampPluginDefinition
